.animate-success {
    transition: color 200ms ease-in-out;
}

.animate-success--active {
    color: var(--green);
}
